import { Controller } from "@hotwired/stimulus"

// Shell of a record's section page (shared/section_nav/_frame; employees, fleets). The pane
// keeps its scroll offset when the details frame swaps sections, so leaving a long Stammdaten
// page would open the next section with its header hidden under the sticky record header.
// When a different section (or record) opens, bring the section's top back into view; a
// re-render of the same section (filter, pagination, a 422 form) keeps its scroll position.
// On every render, drop a jump-list fragment that points at a card this section lacks.
// Last section shown per details frame id. Kept outside the frame element, because a stream
// replacing the record (fleets/update, the photo) swaps the frame itself, not just its content.
const shownSections = new Map()

export default class extends Controller {
  static values = { section: String }

  connect() {
    const changed = this.sectionChanged()
    const hash = window.location.hash
    if (hash && this.element.querySelector(`[id="${CSS.escape(hash.slice(1))}"]`)) return

    if (hash.startsWith("#stammdaten-"))
      window.history.replaceState(
        window.history.state,
        "",
        window.location.pathname + window.location.search,
      )

    if (!changed) return

    const container = this.scrollContainer()
    if (!container) return

    // scroll-margin-top on the element is the height of the sticky header above it.
    const marginTop = parseFloat(getComputedStyle(this.element).scrollMarginTop) || 0
    const visibleTop =
      container === document.scrollingElement ? 0 : container.getBoundingClientRect().top
    const overlap = visibleTop + marginTop - this.element.getBoundingClientRect().top
    if (overlap > 0) container.scrollTop -= overlap
  }

  sectionChanged() {
    const frame = this.element.closest("turbo-frame") || this.element.parentElement
    if (!frame?.id) return true

    const previous = shownSections.get(frame.id)
    shownSections.set(frame.id, this.sectionValue)
    return previous !== this.sectionValue
  }

  scrollContainer() {
    let node = this.element.parentElement
    while (node && node !== document.body) {
      const { overflowY } = getComputedStyle(node)
      if ((overflowY === "auto" || overflowY === "scroll") && node.scrollHeight > node.clientHeight)
        return node
      node = node.parentElement
    }
    return document.scrollingElement
  }
}
